(function () {
  if (window.__bareOptionAvailabilityEnhancerLoaded) return;
  window.__bareOptionAvailabilityEnhancerLoaded = true;

  function parseVariantsJson(root) {
    const script = root.querySelector('[data-variants-json]');
    if (!script) return null;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Failed to parse variant availability JSON.', error);
      return null;
    }
  }

  function getSelectionValue(wrapper) {
    const checkedInput = wrapper.querySelector('input[data-single-option-selector]:checked');
    if (checkedInput) return checkedInput.value;

    const popoutInput = wrapper.querySelector('[data-popout-input]');
    if (popoutInput) return popoutInput.value;

    return null;
  }

  function getSelections(root) {
    const selections = [];

    root.querySelectorAll('[data-selector-wrapper][data-option-position]').forEach((wrapper) => {
      const optionPosition = Number(wrapper.dataset.optionPosition);
      if (!optionPosition) return;

      selections[optionPosition - 1] = getSelectionValue(wrapper);
    });

    return selections;
  }

  function getCurrentOptionValue(wrapper) {
    const selectedInput = wrapper.querySelector('input[data-single-option-selector]:checked');
    if (selectedInput) return selectedInput.value;

    const currentItem = wrapper.querySelector('.select-popout__item--current [data-popout-option]');
    if (currentItem) return currentItem.dataset.value || null;

    return getSelectionValue(wrapper);
  }

  function getOptionState(variants, selections, optionIndex, candidateValue) {
    const matchingVariants = variants.filter((variant) => {
      if (!variant.options || variant.options[optionIndex] !== candidateValue) return false;

      return selections.every((selectedValue, selectedIndex) => {
        if (!selectedValue || selectedIndex === optionIndex) return true;
        return variant.options[selectedIndex] === selectedValue;
      });
    });

    if (!matchingVariants.length) return 'unavailable';
    if (matchingVariants.some((variant) => variant.available)) return 'available';
    return 'sold-out';
  }

  function toggleAvailabilityClasses(element, state) {
    if (!element) return;

    element.classList.toggle('sold-out', state === 'sold-out');
    element.classList.toggle('unavailable', state === 'unavailable');
  }

  function applyState(optionButton, state) {
    toggleAvailabilityClasses(optionButton, state);

    const input = optionButton.querySelector('input');
    if (input) {
      toggleAvailabilityClasses(input, state);
    }
  }

  function applyPopoutState(item, state) {
    toggleAvailabilityClasses(item, state);
    toggleAvailabilityClasses(item?.querySelector('[data-popout-option]'), state);
  }

  function triggerOptionSelection(wrapper, value) {
    if (!wrapper || !value) return;

    const radioInput = Array.from(wrapper.querySelectorAll('input[data-single-option-selector]')).find((input) => input.value === value);
    if (radioInput) {
      radioInput.checked = true;
      radioInput.dispatchEvent(new Event('change', {bubbles: true}));
      return;
    }

    const popoutLink = Array.from(wrapper.querySelectorAll('[data-popout-option]')).find((option) => option.dataset.value === value);
    if (popoutLink) {
      popoutLink.dispatchEvent(new MouseEvent('click', {bubbles: true, cancelable: true}));
    }
  }

  function renderColorSuggestions(productInfo, variants, selections) {
    const suggestionContainer = productInfo.querySelector('[data-option-suggestions]');
    if (!suggestionContainer) return;

    const optionRoot = productInfo.querySelector('[data-option-selectors]') || productInfo;
    const colorWrapper = optionRoot.querySelector('[data-selector-wrapper].selector-wrapper--swatches');
    if (!colorWrapper) {
      suggestionContainer.hidden = true;
      suggestionContainer.innerHTML = '';
      return;
    }

    const colorOptionIndex = Number(colorWrapper.dataset.optionPosition) - 1;
    if (colorOptionIndex < 0) {
      suggestionContainer.hidden = true;
      suggestionContainer.innerHTML = '';
      return;
    }

    const selectedColorValue = getCurrentOptionValue(colorWrapper);
    const selectedColorInput = colorWrapper.querySelector('input[data-single-option-selector]:checked');
    const selectedColorButton = selectedColorInput?.closest('.swatch__button, .radio__button');
    const selectedColorState = selectedColorButton?.classList.contains('unavailable')
      ? 'unavailable'
      : selectedColorButton?.classList.contains('sold-out')
        ? 'sold-out'
        : 'available';

    if (!selectedColorValue || selectedColorState === 'available') {
      suggestionContainer.hidden = true;
      suggestionContainer.innerHTML = '';
      return;
    }

    const availableColorValues = Array.from(colorWrapper.querySelectorAll('input[data-single-option-selector]'))
      .map((input) => input.value)
      .filter((value, index, values) => values.indexOf(value) === index)
      .filter((candidateValue) => {
        if (candidateValue === selectedColorValue) return false;
        return getOptionState(variants, selections, colorOptionIndex, candidateValue) === 'available';
      });

    if (!availableColorValues.length) {
      suggestionContainer.hidden = true;
      suggestionContainer.innerHTML = '';
      return;
    }

    suggestionContainer.innerHTML = '';

    const textNode = document.createTextNode('Available in this size: ');
    suggestionContainer.appendChild(textNode);

    availableColorValues.forEach((value, index) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.textContent = value;
      button.dataset.availableOptionTrigger = '';
      button.dataset.optionPosition = String(colorOptionIndex + 1);
      button.dataset.optionValue = value;
      suggestionContainer.appendChild(button);

      if (index < availableColorValues.length - 2) {
        suggestionContainer.appendChild(document.createTextNode(', '));
      } else if (index === availableColorValues.length - 2) {
        suggestionContainer.appendChild(document.createTextNode(' or '));
      }
    });

    suggestionContainer.appendChild(document.createTextNode('.'));
    suggestionContainer.hidden = false;
  }

  function syncAvailability(productInfo) {
    const optionRoot = productInfo.querySelector('[data-option-selectors]') || productInfo;
    const variants = parseVariantsJson(optionRoot);
    if (!variants || !variants.length) return;

    const selections = getSelections(optionRoot);

    optionRoot.querySelectorAll('[data-selector-wrapper][data-option-position]').forEach((wrapper) => {
      const optionIndex = Number(wrapper.dataset.optionPosition) - 1;
      if (optionIndex < 0) return;

      wrapper.querySelectorAll('.radio__button, .swatch__button').forEach((optionButton) => {
        const input = optionButton.querySelector('input[data-single-option-selector]');
        if (!input) return;

        const state = getOptionState(variants, selections, optionIndex, input.value);
        applyState(optionButton, state);
      });

      const popout = wrapper.querySelector('.select-popout');
      let selectedPopoutState = 'available';

      wrapper.querySelectorAll('.select-popout__item').forEach((item) => {
        const optionLink = item.querySelector('[data-popout-option]');
        const candidateValue = optionLink?.dataset.value;
        if (!candidateValue) return;

        const state = getOptionState(variants, selections, optionIndex, candidateValue);
        applyPopoutState(item, state);

        if (item.classList.contains('select-popout__item--current')) {
          selectedPopoutState = state;
        }
      });

      toggleAvailabilityClasses(popout, selectedPopoutState);
    });

    renderColorSuggestions(productInfo, variants, selections);
  }

  function scheduleSync(productInfo) {
    clearTimeout(productInfo.__optionAvailabilityTimer);
    productInfo.__optionAvailabilityTimer = window.setTimeout(() => {
      syncAvailability(productInfo);
    }, 0);
  }

  function observeVariantSelects(productInfo) {
    const currentOptionRoot = productInfo.querySelector('[data-option-selectors]') || productInfo;
    if (!currentOptionRoot || productInfo.__observedVariantSelects === currentOptionRoot) return;

    if (productInfo.__optionAvailabilityVariantObserver) {
      productInfo.__optionAvailabilityVariantObserver.disconnect();
    }

    const variantObserver = new MutationObserver(() => {
      scheduleSync(productInfo);
    });

    variantObserver.observe(currentOptionRoot, {
      childList: true,
      subtree: true,
    });

    productInfo.__observedVariantSelects = currentOptionRoot;
    productInfo.__optionAvailabilityVariantObserver = variantObserver;
  }

  function initProductInfo(productInfo) {
    if (!productInfo || productInfo.__optionAvailabilityEnhancerInitialized) return;
    productInfo.__optionAvailabilityEnhancerInitialized = true;

    productInfo.addEventListener('change', (event) => {
      if (!event.target.closest('[data-option-selectors]')) return;
      productInfo.__optionAvailabilityHasUserInteracted = true;
      scheduleSync(productInfo);
    });

    productInfo.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-available-option-trigger]');
      if (!trigger) return;

      event.preventDefault();

      const variantSelects = productInfo.querySelector('[data-option-selectors]');
      const optionPosition = Number(trigger.dataset.optionPosition);
      const optionValue = trigger.dataset.optionValue;
      if (!variantSelects || !optionPosition || !optionValue) return;

      const wrapper = variantSelects.querySelector(`[data-selector-wrapper][data-option-position="${optionPosition}"]`);
      triggerOptionSelection(wrapper, optionValue);
    });

    observeVariantSelects(productInfo);

    const observer = new MutationObserver(() => {
      observeVariantSelects(productInfo);
      scheduleSync(productInfo);
    });

    observer.observe(productInfo, {
      childList: true,
    });

    productInfo.__optionAvailabilityObserver = observer;
    scheduleSync(productInfo);
  }

  function initAllProductInfo() {
    document.querySelectorAll('[data-product-info]').forEach(initProductInfo);
  }

  document.addEventListener('DOMContentLoaded', initAllProductInfo);
})();
